export default "__VITE_ASSET__CfjNz6V0__"